import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";
import type { ICompanyHeadquarterFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters";

import type { CompanyHeadquarterFilterOptions } from "./types";

export default class FindCompanyHeadquarterFilter extends FilterPanelBaseFilter<
    ICompanyHeadquarterFilterDto,
    CompanyHeadquarterFilterOptions
> {
    constructor(deps: IFilterPanelBaseFilterDeps<ICompanyHeadquarterFilterDto, CompanyHeadquarterFilterOptions>) {
        super(deps);
    }

    isValueEmpty(value: ICompanyHeadquarterFilterDto | undefined): boolean {
        return !value?.regions?.length && !value?.codes?.length && !value?.zip?.length;
    }

    toApiValue(value: ICompanyHeadquarterFilterDto | undefined): ICompanyHeadquarterFilterDto | undefined {
        if (!value) {
            return undefined;
        }

        const cleanField = <T>(field: readonly T[] | undefined): readonly T[] | undefined =>
            field && field.length ? field : undefined;

        return {
            ...value,
            regions: cleanField(value.regions),
            codes: cleanField(value.codes),
            zip: cleanField(value.zip),
        };
    }

    calculateValueDelta(
        previousValue: ICompanyHeadquarterFilterDto | undefined,
        newValue: ICompanyHeadquarterFilterDto | undefined,
    ): FilterValueDelta<string | number> {
        const previousLocationPull = [
            ...(previousValue?.regions ?? []),
            ...(previousValue?.codes ?? []),
            ...(previousValue?.zip ?? []),
        ];
        const newLocationPull = [...(newValue?.regions ?? []), ...(newValue?.zip ?? []), ...(newValue?.codes ?? [])];

        return calculateArrayDelta(previousLocationPull, newLocationPull);
    }
}
